export type BackButtonTranslation = {
  label: string;
};

export const backButtonTranslation: BackButtonTranslation = {
  label: 'Wstecz',
};
